import { inject, Injectable } from "@angular/core";
import { StakingFacade } from "@modules/staking/domain/+state/staking.facade";
import { Router } from "@angular/router";

@Injectable({ providedIn: "root" })
export class StakingEntryHelperService {
	private readonly stakingFacade = inject(StakingFacade);
	private readonly router = inject(Router);

	public openStakingFlow(stakeableId: string, modalType: string): void {
		if (stakeableId.length > 0) {
			this.stakingFacade.setWalletByTradableId(stakeableId);
		}

		this.router.navigate([{ outlets: { modal: modalType } }], {
			queryParams: { assetId: stakeableId },
			state: {
				stakeableId: stakeableId || ""
			}
		});
	}

	public openFlow(stakeableId?: string): void {
		this.router.navigate([{ outlets: { modal: "stake" } }], {
			queryParams: { assetId: stakeableId },
			state: { stakeableId: stakeableId ?? "" }
		});
	}
}
